// Kept on window rather than in module state: Granite remotes each bundle their
// own copy of this module, and an override installed by the host has to reach
// all of them.
const IMPLEMENTATION_KEY = Symbol.for('hs-browser-apis.setWindowLocationHrefImplementation');
const defaultImplementation = value => {
  window.location.href = value;
};
export function getWindowLocationHrefImplementation() {
  var _IMPLEMENTATION_KEY;
  return (_IMPLEMENTATION_KEY = window[IMPLEMENTATION_KEY]) !== null && _IMPLEMENTATION_KEY !== void 0 ? _IMPLEMENTATION_KEY : defaultImplementation;
}

/**
 * Replaces how `setWindowLocationHref` navigates for every consumer on the
 * page. Only quartz-core is expected to manage this, so there is a single
 * override: setting it again replaces it, and the returned function restores
 * the default behavior.
 */
export function setWindowLocationHrefImplementation(override) {
  window[IMPLEMENTATION_KEY] = override;
  return () => {
    delete window[IMPLEMENTATION_KEY];
  };
}